import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/pc/icons/sprite.png';
const _withScopeId = n => (_pushScopeId("data-v-73d9ced7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "login-box-pc"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  class: "main_message"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "大赢家俱乐部，步步为赢", -1));
const _hoisted_6 = {
  class: "login-btn-common"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "尊敬的尊龙凯时会员，您好:", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请前往尊龙凯时官网进行注册/登录后即可发帖喔！", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $setup.loginBox.show ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "button-close",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.close && $setup.close(...args))
  }, _hoisted_3), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _hoisted_8, _hoisted_9, _hoisted_10, _createElementVNode("div", {
    class: "button-login",
    onClick: _cache[1] || (_cache[1] = $event => $setup.gotoLogin($setup.loginBox.method))
  }, "去官网" + _toDisplayString($setup.buttonMethodText($setup.loginBox.method)), 1)])])])) : _createCommentVNode("", true);
}